angular.module('app').factory('SessionService',
    ['$rootScope',
        function($rootScope) {
            'use strict';

            var sessionParams = {
                PatientAuthenticated: sessionStorage.getItem('PatientAuthenticated') || false, 
                PracticeConsentAccepted: false,
                DisplayDashboardToolbar: false,
                ShowHeaderNavigationMenu: false,
                NewPasswordRequired: false,
                ShowMobileNav: false
            };

            function setNewPasswordRequired (value){
                sessionParams.NewPasswordRequired = value;
            }

            function getNewPasswordRequired() {
                return sessionParams.NewPasswordRequired;
            }
            var setPatientAuthenticated = function (value) {
                sessionParams.PatientAuthenticated = value;
                sessionStorage.setItem('PatientAuthenticated',value);
                $rootScope.$broadcast('PatientAuthenticated:updated', sessionParams.PatientAuthenticated);
            };
            var getPatientAuthenticated = function() {
                return sessionParams.PatientAuthenticated;
            };

            var setPracticeConsentAccepted = function (value) {
                sessionParams.PracticeConsentAccepted = value;
            };
            var getPracticeConsentAccepted = function() {
                return sessionParams.PracticeConsentAccepted;
            };

            var setDisplayDashboardToolbar = function (value) {
                sessionParams.DisplayDashboardToolbar = value;
            };
            var getDisplayDashboardToolbar = function () {
                return sessionParams.DisplayDashboardToolbar;
            };

            var setShowHeaderNavigationMenu = function (value) {
                sessionParams.ShowHeaderNavigationMenu = value;
                $rootScope.$broadcast('ShowHeaderNavigationMenu:updated', sessionParams.ShowHeaderNavigationMenu);
            };
            var getShowHeaderNavigationMenu = function () {
                return sessionParams.ShowHeaderNavigationMenu;
            };
            var setShowMobileNav = function (value){
              sessionParams.ShowMobileNav = value;
              $rootScope.$broadcast('ShowMobileNav:updated', sessionParams.ShowMobileNav);
            };
            var getShowMobileNav = function (){
              return sessionParams.ShowMobileNav;
            };

            var resetSessionParams = function () {
                setPatientAuthenticated(false);
                setPracticeConsentAccepted(false);
                setDisplayDashboardToolbar(false);
                setShowHeaderNavigationMenu(false);
            };


            return {
                resetSessionParams: resetSessionParams,
                setPatientAuthenticated: setPatientAuthenticated,
                getPatientAuthenticated: getPatientAuthenticated,
                setPracticeConsentAccepted: setPracticeConsentAccepted,
                getPracticeConsentAccepted: getPracticeConsentAccepted,
                setDisplayDashboardToolbar: setDisplayDashboardToolbar,
                getDisplayDashboardToolbar: getDisplayDashboardToolbar,
                setShowHeaderNavigationMenu: setShowHeaderNavigationMenu,
                getShowHeaderNavigationMenu: getShowHeaderNavigationMenu,
                getNewPasswordRequired: getNewPasswordRequired,
                setNewPasswordRequired: setNewPasswordRequired,
                setShowMobileNav: setShowMobileNav,
                getShowMobileNav: getShowMobileNav
            };
        }
    ]);